/* Event delegation keeps independently reloaded Shopify sections interactive. */
(() => {
  if (window.lugzStorefrontReady) return;
  window.lugzStorefrontReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    dialog.lgTrigger = trigger;
    dialog.showModal();
    const input = dialog.querySelector('input:not([type="hidden"])');
    if (input) input.focus();
  };
  const activateTab = (button, focus = false) => {
    const section = button.closest('[data-lg-products]');
    if (!section) return;
    section.querySelectorAll('[data-lg-tab]').forEach(tab => {
      const active = tab === button;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    section.querySelectorAll('[data-lg-panel]').forEach(panel => {
      panel.hidden = panel.dataset.lgPanel !== button.dataset.lgTab;
    });
    if (focus) button.focus();
    updateCarousels(section);
  };
  const updateCarousels = (root = document) => {
    root.querySelectorAll('[data-lg-track]').forEach(track => {
      const wrapper = track.closest('.lg-product-carousel');
      const previous = wrapper?.querySelector('[data-lg-scroll="-1"]');
      const next = wrapper?.querySelector('[data-lg-scroll="1"]');
      if (!previous || !next || track.clientWidth === 0) return;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      const showArrows = track.scrollWidth > track.clientWidth + 2;
      previous.hidden = !showArrows;
      next.hidden = !showArrows;
    });
  };
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('[data-lg-menu-open], [data-lg-search-open]');
    if (trigger) {
      openDialog(document.getElementById(trigger.getAttribute('aria-controls')), trigger);
      return;
    }
    const close = target.closest('[data-lg-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (target instanceof HTMLDialogElement && target.open) {
      const bounds = target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) target.close();
    }
    const tab = target.closest('[data-lg-tab]');
    if (tab) { activateTab(tab); return; }
    const arrow = target.closest('[data-lg-scroll]');
    if (arrow) {
      const track = arrow.closest('.lg-product-carousel')?.querySelector('[data-lg-track]');
      track?.scrollBy({ left: Number(arrow.dataset.lgScroll) * (track.clientWidth + 24), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      return;
    }
    const announcement = target.closest('[data-lg-announce-next], [data-lg-announce-prev]');
    if (announcement) advanceAnnouncement(announcement.closest('[data-lg-announcement]'), announcement.hasAttribute('data-lg-announce-prev') ? -1 : 1);
    const cart = target.closest('[data-lg-cart]');
    if (cart) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { event.preventDefault(); drawer.open(); }
    }
    if (!target.closest('.lg-nav-group')) document.querySelectorAll('.lg-nav-group[open]').forEach(details => details.open = false);
  });
  document.addEventListener('keydown', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (event.key === 'Escape') document.querySelectorAll('.lg-nav-group[open]').forEach(details => details.open = false);
    if (!target?.matches('[data-lg-tab]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = Array.from(target.closest('[role="tablist"]').querySelectorAll('[data-lg-tab]'));
    let index = tabs.indexOf(target);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateTab(tabs[index], true);
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.lg-nav-group[open]')) document.querySelectorAll('.lg-nav-group[open]').forEach(other => { if (other !== event.target) other.open = false; });
  }, true);
  document.addEventListener('close', event => {
    if (event.target.matches?.('.lg-section dialog')) event.target.lgTrigger?.focus();
  }, true);
  document.addEventListener('scroll', event => {
    if (event.target.matches?.('[data-lg-track]')) updateCarousels(event.target.closest('[data-lg-products]'));
  }, true);
  const advanceAnnouncement = (section, direction = 1) => {
    if (!section) return;
    const messages = Array.from(section.querySelectorAll('[data-lg-message]'));
    if (messages.length < 2) return;
    const current = Math.max(0, messages.findIndex(message => !message.hidden));
    messages.forEach((message, index) => message.hidden = index !== (current + direction + messages.length) % messages.length);
  };
  const timers = new Map();
  const init = () => {
    updateCarousels();
    for (const [element, timer] of timers) if (!element.isConnected) { clearInterval(timer); timers.delete(element); }
    document.querySelectorAll('[data-lg-announcement]').forEach(section => {
      if (timers.has(section) || reducedMotion.matches) return;
      const timer = setInterval(() => {
        if (!document.hidden && !section.matches(':hover, :focus-within')) advanceAnnouncement(section);
      }, Number(section.dataset.interval) || 6000);
      timers.set(section, timer);
    });
  };
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => setTimeout(init, 0));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-lg-panel]');
    if (panel) {
      const button = panel.closest('[data-lg-products]').querySelector(`[data-lg-tab="${panel.dataset.lgPanel}"]`);
      if (button) activateTab(button);
      event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  });
  window.addEventListener('resize', () => updateCarousels());
  window.addEventListener('load', init, { once: true });
  document.addEventListener('cart:update', event => {
    const cart = event.detail?.data?.cart || event.detail?.cart;
    if (Number.isFinite(cart?.item_count)) document.querySelectorAll('[data-lg-cart-count]').forEach(count => count.textContent = cart.item_count);
  });
  init();
})();
